import * as React from 'react';

import {
    preloader as cssPreloader,
    text      as cssText,
    title     as cssTitle,
    subtitle  as cssSubtitle,
    image     as cssImage,
} from './status-message.module.sass';

export interface IVideoStatusBarProps {
    title: string;
    subTitle: string;
    loader: boolean;
}

export const VideoStatusMessage: React.StatelessComponent<IVideoStatusBarProps> =
({title, subTitle, loader}: IVideoStatusBarProps) => (
    <div className={cssPreloader}>
        <div className={cssText}>
            <h3 className={cssTitle}>{title}</h3>
            <p className={cssSubtitle}>{subTitle}</p>
        </div>
        {loader && <div className={cssImage} />}
    </div>
);
